/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Theme, useTheme, VFlow } from 'bold-ui'
import { useMemo } from 'react'

import { BuscaCidadaoQueryResultModel } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
import { AcompanhamentoCondicaoSaudeAccordionSectionSelector } from './AcompanhamentoCondicaoSaudeAccordionSectionSelector'
import { AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSection } from './AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSection'
import { AcompanhamentoCondicaoSaudeVulnerabilidadesAccordionSection } from './AcompanhamentoCondicaoSaudeVulnerabilidadesAccordionSection'

interface AcompanhamentoCondicaoSaudeAccordionPanelProps {
  row: BuscaCidadaoQueryResultModel
}

export function AcompanhamentoCondicaoSaudeAccordionPanel(
  props: Readonly<AcompanhamentoCondicaoSaudeAccordionPanelProps>
) {
  const { row } = props

  const theme = useTheme()
  const classes = useMemo(() => styles(theme), [theme])

  const iconColor = theme.pallete.gray.c20

  return (
    <VFlow style={classes.container} vSpacing={0}>
      <AcompanhamentoCondicaoSaudeAccordionSectionSelector row={row} iconColor={iconColor} />
      <AcompanhamentoCondicaoSaudeVulnerabilidadesAccordionSection row={row} iconColor={iconColor} />
      <AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSection row={row} iconColor={iconColor} />
    </VFlow>
  )
}

const styles = (theme: Theme) => ({
  container: css`
    padding: 0rem 1rem 0rem 1rem;
    background: ${theme.pallete.gray.c90};
    & > div > div {
      margin: 0;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      border-bottom: 1px solid ${theme.pallete.divider};
    }
    & > div:last-child > div {
      border-bottom: 0;
    }
  `,
})
